module.exports = __webpack_public_path__ + "fonts/GmarketSansTTFBold.6942806.ttf";